module.exports = __webpack_public_path__ + "img/ROI为导向全流程落地帮扶.6ea930b2.png";